import Close from '@mui/icons-material/Close'
import {Box} from '@mui/material'
import {InputTitleNormal} from '../../AdminPanel/common/TitleStyle'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

const RequirementBox = ({props, loading}) => {
  RequirementBox.propTypes = {
    props: PropTypes.props,
    loading: PropTypes.func
  }
  return (
    <RequirementsBlock>
      {!loading && <RequirementsTitle>{props} Name Requirements</RequirementsTitle>}
      <RequirementsRow>
        <Close sx={{fontSize: (theme) => theme.typography.body2.fontSize}} />
        <RequirementsBody>No numbers</RequirementsBody>
      </RequirementsRow>
      <RequirementsRow>
        <Close sx={{fontSize: (theme) => theme.typography.body2.fontSize}} />
        <RequirementsBody>No special characters</RequirementsBody>
      </RequirementsRow>
    </RequirementsBlock>
  )
}

const RequirementsBlock = styled('div', {shouldForwardProp: (prop) => prop !== 'projectReq'})(
  ({theme, projectReq}) => ({
    width: '400px',
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.hpBlack,
    borderRadius: '4px',
    height: '100px', // Changed from 100 to 120
    marginTop: '10px',
    marginLeft: projectReq ? '8.5px' : '4.5px',
    fontSize: theme.typography.body2.fontSize
  })
)

const RequirementsRow = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginLeft: theme.spacing(3)
}))

const RequirementsTitle = styled(InputTitleNormal)(({theme}) => ({
  fontWeight: theme.typography.fontWeightBold,
  paddingLeft: theme.spacing(1.5),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5)
}))

const RequirementsBody = styled(InputTitleNormal)(({theme}) => ({
  fontWeight: theme.typography.fontWeightRegular,
  marginLeft: theme.spacing(0.25),
  lineHeight: theme.spacing(2.2)
}))

export default RequirementBox
